import { render, staticRenderFns } from "./InvalidPosition.vue?vue&type=template&id=58a9a66c&"
import script from "./InvalidPosition.vue?vue&type=script&lang=js&"
export * from "./InvalidPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports